import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextString from '../../components/CLocalizedTextString';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PSectorPerformanceOutlet() {
  const dispatch = useAppDispatch();
  const sectorPerformancePageTitle = CLocalizedTextString('sectorPerformance.route');
  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.SECTOR_PERFORMANCE_OUTLET, sectorPerformancePageTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch,sectorPerformancePageTitle]);
  return <Outlet />;
}
